import React from 'react'
import ModalBasic from '../../component/ModalBasic';
import TextInput from '../../../components/UIComponent/TextInput';
import ToggleSwitch from '../../../components/common/ToggleSwitch';
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'; // ADD THIS IMPORT

function HodPermissionPopup(props) {
    return (
        <ModalBasic
            id="hod-permission"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">HOD details</span>
                <div className='item-grp grid grid-cols-2 gap-2.5 items-start mt-3 mb-3'>

                    <div className='input-grp'>
                        <label>Name</label>
                        <TextInput type='text'
                            id='personName' name='personName'
                            value={props.permissionObject.personName}
                            handleChange={(event) => props.handleChange(event, 'personName')}
                            className={props.validState?.error?.personName !== undefined ? "personName" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Username</label>
                        <TextInput type='text'
                            id='userName' name='userName'
                            value={props.permissionObject.userName}
                            handleChange={(event) => props.handleChange(event, 'userName')}
                            className={props.validState?.error?.userName !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Password</label>
                        <TextInput
                            type="password"
                            id="password"
                            name="password"
                            value={props.permissionObject.password}
                            handleChange={(event) => props.handleChange(event, 'password')}
                            className={props.validState?.error?.password ? "error" : ""}
                            isPassword={true}
                            showPassword={props.showPassword}
                            togglePassword={props.togglePassword}
                        />
                    </div>

                    <div className='input-grp'>
                        <label>Role</label>
                        <MultiSelectDropdown
                            className={props.validState?.error?.roleId !== undefined ? "error" : ""}
                            options={props.roles}
                            value={props.permissionObject.roleId ? props.roles?.find(x => x.value === props.permissionObject.roleId) : null}
                            onChange={(event) => props.handleChangeFroDropdown(event, "roleId")}
                        />
                    </div>

                    <div className='input-grp !flex gap-[10px] items-center mt-5 '>
                        <label>Allow Login</label>
                        <ToggleSwitch
                            checked={props.permissionObject.allowLogin}
                            onChange={(e) => props.handleToggle(e, "allowLogin")}
                        />
                    </div>
                </div>

                {props.selectedId > 0 ?
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="update-btn btns" onClick={() => props.submit()}>Update</button>
                        <button className="delete-btn btns" onClick={() => props.delete()}>Delete</button>
                    </div>
                    :
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                }

            </div>

        </ModalBasic>
    )
}

export default HodPermissionPopup